import Block from '../block'

export default class SubNav extends Block {
	static title = 'subnav'

	init() {
		this.closeButton = this.getElement('close')
		if (this.closeButton) {
			this.closeButton.addEventListener('click', () => this.close())
		}

		if (this.overlay) {
			this.overlay.addEventListener('click', () => this.close())
		}

		if (!this.element.dataset.persist) {
			this.element.addEventListener('mouseenter', () => this.open())
			this.element.addEventListener('mouseleave', () => this.close())
		}

		this.eventEmitter.on('nav:toggle-subnav', obj => {
			if (obj.subnavId === this.element.getAttribute('data-subnav-id')) {
				this.open()
				return
			}

			this.close()
		})
	}

	toggle() {
		if (this.hasModifier('hidden') || !this.hasModifier('active')) {
			this.open()
			return
		}
		this.close()
	}

	open() {
		this.removeModifier('hidden')
		this.addModifier('active')
	}

	close() {
		this.addModifier('hidden')
		this.removeModifier('active')
	}
}
